import { Injectable } from '@angular/core';
import { Headers, Http, Response} from '@angular/http';
import { Nalgene } from '../nalgene';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ProductsService {

  constructor(public http:Http) { }


  getNalgenes(): Promise<Nalgene[]> {
    //let nalgenesUrl = 'http://localhost:3000/nalgenes.json';
    //let nalgenesUrl = "https://nalgene-api.herokuapp.com/nalgenes.json"
    //let nalgenesUrl = "http://nalgene-api-dev.us-east-2.elasticbeanstalk.com/nalgenes.json"
    let nalgenesUrl = "https://nalgene-api1.thermofisher.com/nalgenes.json"
    //let nalgenesUrl = "http://nalgene-api-dev.us-east-1.elasticbeanstalk.com/nalgenes.json"
    return this.http.get(nalgenesUrl)
    .toPromise()
    .then(this.extractData)
    .catch(this.handleError);
  }


  private extractData(res: Response) {
    let body = res.json();
    //console.log(body.data);
    //return body.data || { };
    console.log(body);
    return body;
  }

  private handleError(error:any): Promise<any> {
      window.alert(`An Error occured: ${error} `);
      //console.error("OOPS", error);
      return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/nalgenes/products.service.ts